import React from 'react';
import {
  FormControl, InputLabel, Select, MenuItem, OutlinedInput, Box, Chip,
} from '@mui/material';
import {
  SYNC_PROVIDER_OPTIONS,
  SYNC_TYPE_OPTIONS,
  SYNC_MODE_OPTIONS,
  SYNC_TRIGGER_OPTIONS,
  SYNC_RUN_STATUS_OPTIONS,
  SYNC_RUN_STATUS_LABELS,
  SYNC_RUN_STATUS_COLORS,
} from '../../../constants/ingestionSyncRuns';
import { FilterBar } from './styles';
import { getChipSx } from '../DirectManagerDiscrepancies/chipStyles';

const renderStatusChips = (selected) => {
  if (!selected || selected.length === 0) {
    return <em>None</em>;
  }
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
      {selected.map((value) => (
        <Chip
          key={value}
          label={SYNC_RUN_STATUS_LABELS[value] || value}
          size="small"
          sx={getChipSx(SYNC_RUN_STATUS_COLORS[value])}
        />
      ))}
    </Box>
  );
};

const SingleSelect = ({ id, label, value, options, onChange, minWidth = 160 }) => (
  <FormControl size="small" sx={{ minWidth }}>
    <InputLabel id={id}>{label}</InputLabel>
    <Select labelId={id} label={label} value={value || ''} onChange={(event) => onChange(event.target.value)}>
      <MenuItem value=""><em>All</em></MenuItem>
      {options.map((opt) => (
        <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
      ))}
    </Select>
  </FormControl>
);

const RunsFilterBar = ({ provider, syncType, mode, trigger, status, onChange }) => (
  <FilterBar>
    <SingleSelect
      id="isr-provider-label"
      label="Provider"
      value={provider}
      options={SYNC_PROVIDER_OPTIONS}
      onChange={(value) => onChange({ provider: value })}
    />
    <SingleSelect
      id="isr-sync-type-label"
      label="Sync"
      value={syncType}
      options={SYNC_TYPE_OPTIONS}
      onChange={(value) => onChange({ syncType: value })}
    />
    <SingleSelect
      id="isr-mode-label"
      label="Mode"
      value={mode}
      options={SYNC_MODE_OPTIONS}
      onChange={(value) => onChange({ mode: value })}
    />
    <SingleSelect
      id="isr-trigger-label"
      label="Trigger"
      value={trigger}
      options={SYNC_TRIGGER_OPTIONS}
      onChange={(value) => onChange({ trigger: value })}
    />
    <FormControl size="small" sx={{ minWidth: 220 }}>
      <InputLabel id="isr-status-label">Status</InputLabel>
      <Select
        labelId="isr-status-label"
        multiple
        value={status || []}
        onChange={(event) => {
          const { value } = event.target;
          onChange({ status: typeof value === 'string' ? value.split(',') : value });
        }}
        input={<OutlinedInput label="Status" />}
        renderValue={renderStatusChips}
      >
        {SYNC_RUN_STATUS_OPTIONS.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            <Chip label={opt.label} size="small" sx={getChipSx(SYNC_RUN_STATUS_COLORS[opt.value])} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </FilterBar>
);

export default RunsFilterBar;
